
export default class ReduxTodoController {
  disconnect;
  $ngRedux;

  constructor($log, $ngRedux, iceApplicationPreferences, $translate, $state, $scope) {
    'ngInject';

    this.logger = $log.getInstance('MainHeaderController');
    this.$ngRedux = $ngRedux;
    this.icePrefs = iceApplicationPreferences;
    this.$translate = $translate;
    this.$state = $state;
    this.$scope = $scope;
  }

  $onInit () {
    this.logger.debug('$onInit', this.$ngRedux);

    let actionCreators = { };
    this.disconnect = this.$ngRedux.connect(this._mapStateToThis.bind(this), actionCreators)(this);

    // TODO connect preferences with ReDux !
    this._applyPreferences();
    this.$scope.$on(this.icePrefs.getPreferencesChangedNamespace(), this._applyPreferences.bind(this));
  }

  _mapStateToThis (state) {
    return {
      currentLanguage: this.$translate.use(),
      languages: {
        'it_IT': { id: 'it_IT', label: 'Italiano' },
        'en_EN': { id: 'en_EN', label: 'English' }
      }
    };
  }

  changeLanguage ($event) {
    this.$translate.use($event.id);
    this.currentLanguage = this.$translate.use();
  }

  navbarBrandAction () {
    this.$state.go('examples.fecon-splash');
  }

  _applyPreferences () {
    let prefs = this.icePrefs;

    this.pref = {
      brandText: prefs.getPref('layouts.main.main-header.brand-logo.txt'),
      brandImage: prefs.getPref('layouts.main.main-header.brand-logo.img')
    };

  }


  $onDestroy () {
    this.disconnect();
  }

}



// WEBPACK FOOTER //
// ./client/app/layout/main-layout/main-header/main-header.controller.js